export const StakeManagerEvents = {
  GetStakedNFTs: 'StakeManager.GetStakedNFTs',
  StakedNFTsReturned: 'StakeManager.StakedNFTsReturned',

  StakeNFT: 'StakeManager.StakeNFT',
  StakeNFTCompleted: 'StakeManager.StakeNFTCompleted',

  SetApprovalForAll: 'StakeManager.SetApprovalForAll',
  SetApprovalForAllCompleted: 'StakeManager.SetApprovalForAllCompleted',

  StakeAllNFTs: 'StakeManager.StakeAllNFTs',
  StakeAllNFTsCompleted: 'StakeManager.StakeAllNFTsCompleted',

  WithdrawNFT: 'StakeManager.WithdrawNFT',
  WithdrawNFTCompleted: 'StakeManager.WithdrawNFTCompleted',

  BatchStakeNFTs: 'StakeManager.BatchStakeNFTs',
  BatchStakeNFTsCompleted: 'StakeManager.BatchStakeNFTsCompleted',

  ApproveCompleted: 'StakeManager.ApproveCompleted',

  GetAllowedCover: 'StakeManager.GetAllowedCover',
  AllowedCoverReturned: 'StakeManager.AllowedCoverReturned',

  GetTotalStakedAmount: 'StakeManager.GetTotalStakedAmount',
  TotalStakedAmountReturned: 'StakeManager.TotalStakedAmountReturned',

  GetPendingWithdrawals: 'StakeManager.GetPendingWithdrawals',
  PendingWithdrawalsReturned: 'StakeManager.PendingWithdrawalsReturned',

  GetTotalAvailable: 'StakeManager.GetTotalAvailable',
  TotalAvailableReturned: 'StakeManager.TotalAvailableReturned',
}
